import { render, staticRenderFns } from "./FindOpportunityRelated.vue?vue&type=template&id=207cebd7&"
import script from "./FindOpportunityRelated.vue?vue&type=script&lang=js&"
export * from "./FindOpportunityRelated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports